<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource">
    <!-- Project Details Column -->
    <ng-container matColumnDef="project">
      <th mat-header-cell *matHeaderCellDef>Project Details</th>
      <td mat-cell *matCellDef="let element" class="username-cell">
        <div>
          {{ element?.name }}
        </div>
        <!-- <div>{{element?.project?.org}}</div>
        <div>Version: <strong>{{element?.project?.version}}</strong></div> -->
      </td>
    </ng-container>

    <!-- Project Code Column -->
    <ng-container matColumnDef="project_code">
      <th mat-header-cell *matHeaderCellDef>Project Code</th>
      <td mat-cell *matCellDef="let element" class="username-cell">
        <div>
          {{ element.project_code }}
        </div>
        <div>{{element?.app?.name}}</div>
        <!-- <div>Version: <strong>{{element?.project?.version}}</strong></div> -->
      </td>
    </ng-container>

    <!-- Client Deatils Column -->
    <ng-container matColumnDef="client">
      <th mat-header-cell *matHeaderCellDef>Client Details</th>
      <td mat-cell *matCellDef="let element" class="username-cell">
        <div>{{ element?.client?.name }}</div>
        <div>{{ element?.client?.state }}</div>
      </td>
    </ng-container>

    <!-- Registered Date Column -->
    <ng-container matColumnDef="regDate">
      <th mat-header-cell *matHeaderCellDef>Registered Date</th>
      <td mat-cell *matCellDef="let element" class="username-cell">
        <div>{{ element?.created_at | dateFormat }}</div>
      </td>
    </ng-container>

    <!-- Proj Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element"  class="username-cell">
        <div class="project-name" [ngClass]="{'error':element?.submission_status === 'REJECTED'}">{{ element?.status === 'CLOSED' ? element?.submission_status : element?.status }}</div>
        @if (!element.is_project_rated) {
          <div class="project-desc">
            Pending at {{element?.pending_at}} Level
          </div>
        }
        <div class="project-desc-title">
          Optional Site Visit : @if (element.site_visit_optional_status) {
          <span class="project-desc">{{ element.site_visit_optional_status }}</span>
        } @else {
          <span class="no-record">NA</span>
        }
      </div>
      <div class="project-desc-title">
        Workshop : @if (element.workshop_status) {
        <span class="project-desc">{{ element.workshop_status }}</span>
      } @else {
        <span class="no-record">NA</span>
      }
    </div>
    <div class="project-desc-title">
      Final Site Visit : @if (element.site_visit_mandatory_status) {
      <span class="project-desc">{{ element.site_visit_mandatory_status }}</span>
    } @else {
      <span class="no-record">NA</span>
    }
  </div>
</td>
</ng-container>

<!-- Proj Type Column -->
<ng-container matColumnDef="type">
  <th mat-header-cell *matHeaderCellDef>Type</th>
  <td mat-cell *matCellDef="let element"  class="username-cell">
    <div>{{ element?.type }}</div>
  </td>
</ng-container>

<!-- Proj Coordinator Column -->
<ng-container matColumnDef="coordinator">
  <th mat-header-cell *matHeaderCellDef>Coordinator</th>
  <td mat-cell *matCellDef="let element" class="username-cell">
    @if (element.coordinator?.name) {
      <div>
        {{ element?.coordinator?.name }}
      </div>
    } @else {
      <span class="no-record">NA</span>
    }
  </td>
</ng-container>

<!-- Proj Coordinator Column -->
<ng-container matColumnDef="actions">
  <th mat-header-cell *matHeaderCellDef>Actions</th>
  <td mat-cell *matCellDef="let element">
    <app-action-column [rowData]="element" [canView]="canView" [canEdit]="canEdit" [canDelete]="canDelete"
      [canAssignCoordinator]="canAssignCoordinator" [canInitiateProject]="canInitiateProject"
      [canViewLogs]="canViewLogs" (delete)="onDelete($event)" (edit)="onEdit($event)" (view)="onView($event)" [canViewSettings]="canViewSettings" (viewSettings)="onViewSettings($event)"
      (initiate)="onInitiate($event)" (assignUser)="onAssignUser($event)" (viewActivity)="onViewLogs($event)">
    </app-action-column>
  </td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of Projects" [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex" (page)="onPageChange($event)">
</mat-paginator>
</div>